/**
 * Abre una URL en una pestaña nueva de forma confiable después de un
 * `await` (ej. esperar la URL con SAS del backend). `window.open(url)`
 * llamado después de un await pierde el "user gesture" del click original
 * — el browser abre una pestaña pero bloquea la navegación en silencio,
 * quedando en blanco (bug real encontrado 07/08/2026, ver docs/Decisions.md).
 * Un <a target="_blank"> clickeado programáticamente no tiene esa
 * restricción.
 */
export function abrirEnNuevaPestana(url: string) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
